import React from 'react';

const Icon = ({ name, className = '', style, ariaHidden = true, ...rest }) => (
  <span
    className={className ? `material-symbols-outlined ${className}` : 'material-symbols-outlined'}
    aria-hidden={ariaHidden}
    style={style}
    {...rest}
  >
    {name}
  </span>
);

export default Icon;
